import { Injectable, signal } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { LocalStorageService } from 'src/app/common/services/local-storage.service';
import { ApiConstants } from 'src/app/common/constants/api-url.constant';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FaqService {

  constructor(private storageService: LocalStorageService, private http: HttpClient) {

  }

  getFAQList(category: string): Observable<any> {
    return this.http.get(ApiConstants.GET_FAQ_LIST(category))
  }

}
